import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useDeductibleVat(period) {
  return useQuery({
    queryKey: ['vat-deductible', period],
    queryFn: () => api.get(`/vat/deductible?period=${period}`),
    enabled: !!period,
    staleTime: 30_000,
  });
}
